export const personalInfo =
    [
        {
            ID: 1,
            NOMBRE: "Descripci%C3%B3n%20principal",
            VALOR: "%3Cp%20class%3D%22custom-weight-lighter%20custom-description%20pt-5%22%3ELorem%20ipsum%20dolor%20sit%20amet%2C%20consectetur%20adipiscing%20elit%2C%20sed%20do%20eiusmod%20tempor%20incididunt%20ut%20labore%20et%20dolore%20magna%20aliqua.%20Ut%20enim%20ad%20minim%20veniam%2C%20quis%20nostrud%20exercitation%20ullamco%20laboris%20nisi%20ut%20aliquip%20ex%20ea%20commodo%20consequat.%3C%2Fp%3E%3Cp%20class%3D%22custom-weight-lighter%20custom-description%20pt-5%22%3ELorem%20ipsum%20dolor%20sit%20amet%2C%20consectetur%20%3Cspan%20class%3D%22custom-weight-bolder%20custom-text-black%22%3Eadipiscing%20elit%3C%2Fspan%3E%2C%20sed%20do%20eiusmod%20tempor%20incididunt%20ut%20labore%20et%20dolore%20magna%20aliqua.%20Ut%20enim%20ad%20minim%20veniam%2C%20quis%20nostrud%20exercitation%20ullamco%20laboris%20nisi%20ut%20aliquip%20ex%20ea%20commodo%20consequat.%3C%2Fp%3E",
            TITULO_LABEL_HTML: null,
            HREF: null
        },
        {
            ID: 2,
            NOMBRE: "T%C3%ADtulo%20blog%20light",
            VALOR: "Soy",
            TITULO_LABEL_HTML: null,
            HREF: null
        },
        {
            ID: 3,
            NOMBRE: "T%C3%ADtulo%20blog%20bold",
            VALOR: "Agust%C3%ADn%20Galluzzo",
            TITULO_LABEL_HTML: null,
            HREF: null
        },
        {
            ID: 4,
            NOMBRE: "Subtitulo%20blog",
            VALOR: "Bienvenidos%20a%20mi%20blog%21",
            TITULO_LABEL_HTML: null,
            HREF: null
        },
        {
            ID: 5,
            NOMBRE: "Stats%201",
            VALOR: "340",
            TITULO_LABEL_HTML: "Stats%201",
            HREF: null
        },
        {
            ID: 6,
            NOMBRE: "Stats%202",
            VALOR: "40",
            TITULO_LABEL_HTML: "Stats%202",
            HREF: null
        },
        {
            ID: 7,
            NOMBRE: "Email",
            VALOR: "info.ardevs%40gmail.com",
            TITULO_LABEL_HTML: "envelope",
            HREF: "mailto:info.ardevs%40gmail.com"
        },
        {
            ID: 8,
            NOMBRE: "Tel%C3%A9fono",
            VALOR: "%2B54%209%2011%203090-6605",
            TITULO_LABEL_HTML: "phone-alt",
            HREF: "tel%3A%2B54%209%2011%203090-6605"
        },
        {
            ID: 9,
            NOMBRE: "Ubicaci%C3%B3n",
            VALOR: "Buenos%20Aires%2C%20Argentina",
            TITULO_LABEL_HTML: "map-marker-alt",
            HREF: null
        },
        {
            ID: 10,
            NOMBRE: "Acerca%20de%20m%C3%AD",
            VALOR: "%3Cp%20class%3D%22custom-description%20text-justify%22%3ELorem%20ipsum%20dolor%20sit%20amet%2C%20consectetur%20adipiscing%20elit%2C%20sed%20do%20eiusmod%20tempor%20incididunt%20ut%20labore%20et%20dolore%20magna%20aliqua.%20Ut%20enim%20ad%20minim%20veniam%2C%20quis%20nostrud%20exercitation%20ullamco%20laboris%20nisi%20ut%20aliquip%20ex%20ea%20commodo%20consequat.%3C%2Fp%3E%3Cp%20class%3D%22custom-description%20text-justify%22%3ELorem%20ipsum%20dolor%20sit%20amet%2C%20consectetur%20adipiscing%20elit%2C%20sed%20do%20eiusmod%20tempor%20incididunt%20ut%20labore%20et%20dolore%20magna%20aliqua.%20Ut%20enim%20ad%20minim%20veniam%2C%20quis%20nostrud%20exercitation%20ullamco%20laboris%20nisi%20ut%20aliquip%20ex%20ea%20commodo%20consequat.%3C%2Fp%3E%3Cp%20class%3D%22custom-description%20text-justify%22%3ELorem%20ipsum%20dolor%20sit%20amet%2C%20consectetur%20adipiscing%20elit%2C%20sed%20do%20eiusmod%20tempor%20incididunt%20ut%20labore%20et%20dolore%20magna%20aliqua.%20Ut%20enim%20ad%20minim%20veniam%2C%20quis%20nostrud%20exercitation%20ullamco%20laboris%20nisi%20ut%20aliquip%20ex%20ea%20commodo%20consequat.%3C%2Fp",
            TITULO_LABEL_HTML: null,
            HREF: null
        },
        {
            ID: 11,
            NOMBRE: "Facebook",
            VALOR: "https%3A%2F%2Fwww.facebook.com%2Fagus.galluzzo",
            TITULO_LABEL_HTML: "facebook-f",
            HREF: null
        },
        {
            ID: 12,
            NOMBRE: "Instagram",
            VALOR: "https%3A%2F%2Finstagram.com%2Fagusgalluzzo",
            TITULO_LABEL_HTML: "instagram",
            HREF: null
        },
        {
            ID: 13,
            NOMBRE: "Twitter",
            VALOR: "https%3A%2F%2Ftwitter.com%2Fagusgalluzzo%2F",
            TITULO_LABEL_HTML: "twitter",
            HREF: null
        },
        {
            ID: 14,
            NOMBRE: "LinkedIn",
            VALOR: "https%3A%2F%2Fwww.linkedin.com%2Fin%2Fagustin-galluzzo-57a88718a%2F",
            TITULO_LABEL_HTML: "linkedin",
            HREF: "https%3A%2F%2Fwww.linkedin.com%2Fin%2Fagustin-galluzzo-57a88718a%2F"
        },
        {
            ID: 15,
            NOMBRE: "Imagen%20principal",
            VALOR: "periodismo-deportivo-2.jpg",
            TITULO_LABEL_HTML: "Imagen%20principal",
            HREF: null
        },
        {
            ID: 16,
            NOMBRE: "Whatsapp",
            VALOR: "https%3A%2F%2Fapi.whatsapp.com%2Fsend%3Fphone%3D5491130906605",
            TITULO_LABEL_HTML: "whatsapp",
            HREF: null
        },
        {
            ID: 17,
            NOMBRE: "CV",
            VALOR: "CV-Spanish.pdf",
            TITULO_LABEL_HTML: null,
            HREF: null
        }
    ];

export const socialNetworks =
    [
        {
            ID: 1,
            NOMBRE: "Whatsapp",
            VALOR: "https%3A%2F%2Fapi.whatsapp.com%2Fsend%3Fphone%3D5491130906605",
            ICONO: "whatsapp"
        },
        {
            ID: 2,
            NOMBRE: "Instagram",
            VALOR: "https%3A%2F%2Finstagram.com%2Fagusgalluzzo",
            ICONO: "instagram"
        },
        {
            ID: 3,
            NOMBRE: "Facebook",
            VALOR: "https%3A%2F%2Fwww.facebook.com%2Fagus.galluzzo",
            ICONO: "facebook-f"
        },
        {
            ID: 4,
            NOMBRE: "Twitter",
            VALOR: "https%3A%2F%2Ftwitter.com%2Fagusgalluzzo%2F",
            ICONO: "twitter"
        },
        {
            ID: 5,
            NOMBRE: "LinkedIn",
            VALOR: "https%3A%2F%2Fwww.linkedin.com%2Fin%2Fagustin-galluzzo-57a88718a%2F",
            ICONO: "linkedin-in"
        }
    ];

export const imagesPrincipal =
    [
        {
            ID: 1,
            SRC_IMAGEN: "periodismo-deportivo.jpg",
            TITULO: "Prueba%201"
        },
        {
            ID: 2,
            SRC_IMAGEN: "periodismo-deportivo.jpg",
            TITULO: "Imagen%202"
        }
    ];

export const posts =
    [
        {
            ID: 4,
            ID_TIPO_POST: 2,
            TITULO: "Prueba%203",
            IMAGEN_PRINCIPAL: "un-ano-de-locos.jpg",
            FECHA: "2021-01-19T03:00:00.000Z",
            DESCRIPCION: "Lorem%20ipsum%20dolor%20sit%20amet%2C%20consectetur%20adipiscing%20elit%2C%20sed%20do%20eiusmod%20tempor%20incididunt%20ut%20labore%20et%20dolore%20magna%20aliqua.%20Ut%20enim%20ad%20minim%20veniam%2C%20quis%20nostrud%20exercitation%20ullamco%20laboris%20nisi%20ut%20aliquip%20ex%20ea%20commodo%20consequat.",
            LINK_SPOTIFY: null,
            LINK_INSTAGRAM: null,
            LINK_YOUTUBE: null,
            TIENE_AUDIO: 0,
            TIENE_VIDEO: 0,
            TIENE_ARTICULO: 0,
            FULL_ARTICULO: null,
            SRC_VIDEO: null,
            SRC_AUDIO: null,
            ACTIVO: 1,
            ELIMINADO: 0,
            URL_POST: "prueba-3",
            TIPO: "PeP"
        },
        {
            ID: 5,
            ID_TIPO_POST: 3,
            TITULO: "Prueba%204",
            IMAGEN_PRINCIPAL: "un-ano-de-locos.jpg",
            FECHA: "2021-01-19T03:00:00.000Z",
            DESCRIPCION: "Lorem%20ipsum%20dolor%20sit%20amet%2C%20consectetur%20adipiscing%20elit%2C%20sed%20do%20eiusmod%20tempor%20incididunt%20ut%20labore%20et%20dolore%20magna%20aliqua.%20Ut%20enim%20ad%20minim%20veniam%2C%20quis%20nostrud%20exercitation%20ullamco%20laboris%20nisi%20ut%20aliquip%20ex%20ea%20commodo%20consequat.",
            LINK_SPOTIFY: null,
            LINK_INSTAGRAM: null,
            LINK_YOUTUBE: null,
            TIENE_AUDIO: 0,
            TIENE_VIDEO: 0,
            TIENE_ARTICULO: 0,
            FULL_ARTICULO: null,
            SRC_VIDEO: null,
            SRC_AUDIO: null,
            ACTIVO: 1,
            ELIMINADO: 0,
            URL_POST: "prueba-4",
            TIPO: "Notas%20personales"
        },
        {
            ID: 2,
            ID_TIPO_POST: 2,
            TITULO: "Prueba",
            IMAGEN_PRINCIPAL: "un-ano-de-locos.jpg",
            FECHA: "2021-01-17T03:00:00.000Z",
            DESCRIPCION: "Lorem%20ipsum%20dolor%20sit%20amet%2C%20consectetur%20adipiscing%20elit%2C%20sed%20do%20eiusmod%20tempor%20incididunt%20ut%20labore%20et%20dolore%20magna%20aliqua.%20Ut%20enim%20ad%20minim%20veniam%2C%20quis%20nostrud%20exercitation%20ullamco%20laboris%20nisi%20ut%20aliquip%20ex%20ea%20commodo%20consequat.Lorem%20ipsum%20dolor%20sit%20ametaaaaaaaa.a",
            LINK_SPOTIFY: null,
            LINK_INSTAGRAM: null,
            LINK_YOUTUBE: "https%3A%2F%2Fwww.youtube.com%2FzpOULjyy-n8%3Frel%3D0",
            TIENE_AUDIO: 0,
            TIENE_VIDEO: 1,
            TIENE_ARTICULO: 0,
            FULL_ARTICULO: null,
            SRC_VIDEO: "https%3A%2F%2Fwww.youtube.com%2Fembed%2FzpOULjyy-n8%3Frel%3D0",
            SRC_AUDIO: null,
            ACTIVO: 1,
            ELIMINADO: 0,
            URL_POST: "prueba",
            TIPO: "PeP"
        },
        {
            ID: 3,
            ID_TIPO_POST: 2,
            TITULO: "Prueba%202",
            IMAGEN_PRINCIPAL: "periodismo-deportivo.jpg",
            FECHA: "2021-01-17T03:00:00.000Z",
            DESCRIPCION: "Lorem%20ipsum%20dolor%20sit%20amet%2C%20consectetur%20adipiscing%20elit%2C%20sed%20do%20eiusmod%20tempor%20incididunt%20ut%20labore%20et%20dolore%20magna%20aliqua.%20Ut%20enim%20ad%20minim%20veniam%2C%20quis%20nostrud%20exercitation%20ullamco%20laboris%20nisi%20ut%20aliquip%20ex%20ea%20commodo%20consequat.",
            LINK_SPOTIFY: null,
            LINK_INSTAGRAM: null,
            LINK_YOUTUBE: null,
            TIENE_AUDIO: 0,
            TIENE_VIDEO: 0,
            TIENE_ARTICULO: 1,
            FULL_ARTICULO: "%3Cp%20class%3D%22custom-description%20text-justify%22%3ELorem%20ipsum%20dolor%20sit%20amet%2C%20consectetur%20adipiscing%20elit%2C%20sed%20do%20eiusmod%20tempor%20incididunt%20ut%20labore%20et%20dolore%20magna%20aliqua.%20Ut%20enim%20ad%20minim%20veniam%2C%20quis%20nostrud%20exercitation%20ullamco%20laboris%20nisi%20ut%20aliquip%20ex%20ea%20commodo%20consequat.%3C%2Fp%3E%3Cp%20class%3D%22custom-description%20text-justify%22%3ELorem%20ipsum%20dolor%20sit%20amet%2C%20consectetur%20adipiscing%20elit%2C%20sed%20do%20eiusmod%20tempor%20incididunt%20ut%20labore%20et%20dolore%20magna%20aliqua.%20Ut%20enim%20ad%20minim%20veniam%2C%20quis%20nostrud%20exercitation%20ullamco%20laboris%20nisi%20ut%20aliquip%20ex%20ea%20commodo%20consequat.%3C%2Fp%3E%3Cp%20class%3D%22custom-description%20text-justify%22%3ELorem%20ipsum%20dolor%20sit%20amet%2C%20consectetur%20adipiscing%20elit%2C%20sed%20do%20eiusmod%20tempor%20incididunt%20ut%20labore%20et%20dolore%20magna%20aliqua.%20Ut%20enim%20ad%20minim%20veniam%2C%20quis%20nostrud%20exercitation%20ullamco%20laboris%20nisi%20ut%20aliquip%20ex%20ea%20commodo%20consequat.%3C%2Fp",
            SRC_VIDEO: null,
            SRC_AUDIO: null,
            ACTIVO: 1,
            ELIMINADO: 0,
            URL_POST: "prueba-2",
            TIPO: "PeP"
        },
        {
            ACTIVO: 1,
            DESCRIPCION: "Fin%20de%20a%C3%B1o.%20%C3%9Altimo%20cap%C3%ADtulo%20del%20a%C3%B1o%20en%20el%20Deporte%20supera%20la%20Ficci%C3%B3n.%20Esta%20vez%20no%20habr%C3%A1%20historias%20ins%C3%B3litas%20o%20hechos%20in%C3%A9ditos.%20Esta%20vez%20se%20har%C3%A1%20presente%20una%20persona%20que%20re%C3%BAne%20todas%20esas%20cosas.%20Rub%C3%A9n%20L%C3%B3pez%20es%20el%20hombre%2C%20que%20a%20trav%C3%A9s%20del%20deporte%2C%20super%C3%B3%20a%20la%20ficci%C3%B3n.%20Es%20CEO%20de%20la%20Foundation%20Invencible%20y%20realiza%20desaf%C3%ADos%20deportivos%20extremos%20con%20fines%20solidarios.%20Midi%C3%B3%20su%20capacidad%20f%C3%ADsica%20y%20mental%20en%20el%20Tri%C3%A1ngulo%20de%20la%20Bermudas%2C%20el%20Amazonas%2C%20el%20Aconcagua%2C%20el%20Desierto%20de%20Atacama%20y%20dem%C3%A1s.%20Una%20charla%20exclusiva%20hablando%20del%208xWORLD%2C%20sus%20pr%C3%B3ximos%20retos%20para%20el%202021.%20Este%20%C3%BAltimo%20cap%C3%ADtulo%20transcurre%20en%20la%20cena%20de%20a%C3%B1o%20nuevo%20de%20dos%20amigos%20que%20hicieron%20posible%20este%20Podcast.%20Por%20%C3%BAltima%20vez%20en%20el%20a%C3%B1o%2C%20pasen%20y%20escuchen...",
            ELIMINADO: 0,
            FECHA: "2021-01-14T03:00:00.000Z",
            FULL_ARTICULO: "%3Cp%20class%3D%22custom-description%20text-justify%22%3ELorem%20ipsum%20dolor%20sit%20amet%2C%20consectetur%20adipiscing%20elit%2C%20sed%20do%20eiusmod%20tempor%20incididunt%20ut%20labore%20et%20dolore%20magna%20aliqua.%20Ut%20enim%20ad%20minim%20veniam%2C%20quis%20nostrud%20exercitation%20ullamco%20laboris%20nisi%20ut%20aliquip%20ex%20ea%20commodo%20consequat.%3C%2Fp%3E%3Cp%20class%3D%22custom-description%20text-justify%22%3ELorem%20ipsum%20dolor%20sit%20amet%2C%20consectetur%20adipiscing%20elit%2C%20sed%20do%20eiusmod%20tempor%20incididunt%20ut%20labore%20et%20dolore%20magna%20aliqua.%20Ut%20enim%20ad%20minim%20veniam%2C%20quis%20nostrud%20exercitation%20ullamco%20laboris%20nisi%20ut%20aliquip%20ex%20ea%20commodo%20consequat.%3C%2Fp%3E%3Cp%20class%3D%22custom-description%20text-justify%22%3ELorem%20ipsum%20dolor%20sit%20amet%2C%20consectetur%20adipiscing%20elit%2C%20sed%20do%20eiusmod%20tempor%20incididunt%20ut%20labore%20et%20dolore%20magna%20aliqua.%20Ut%20enim%20ad%20minim%20veniam%2C%20quis%20nostrud%20exercitation%20ullamco%20laboris%20nisi%20ut%20aliquip%20ex%20ea%20commodo%20consequat.%3C%2Fp",
            ID: 1,
            ID_TIPO_POST: 1,
            IMAGEN_PRINCIPAL: "un-ano-de-locos.jpg",
            LINK_INSTAGRAM: "https%3A%2F%2Fwww.instagram.com%2Fp%2FCJgi-VjJkX1%2F",
            LINK_SPOTIFY: "https%3A%2F%2Fopen.spotify.com%2Fepisode%2F1YFkxSvzsQ7wJHypwTdZPc",
            LINK_YOUTUBE: null,
            SRC_AUDIO: "P25E8.mp3",
            SRC_VIDEO: null,
            TIENE_ARTICULO: 1,
            TIENE_AUDIO: 1,
            TIENE_VIDEO: 0,
            TIPO: "Supera%20la%20Ficci%C3%B3n",
            TITULO: "Un%20A%C3%B1o%20de%20Locos",
            URL_POST: "un-ano-de-locos"
        }
    ];

export const postSelectedImages =
    [
        { ID: 2, ID_POST: 1, SRC_IMAGEN: "periodismo-deportivo.jpg", TITULO: "Imagen%201", URL_POST: "un-ano-de-locos" },
        { ID: 3, SRC_IMAGEN: "periodismo-deportivo.jpg", TITULO: "Imagen%202", ID_POST: 1, URL_POST: "un-ano-de-locos" },
        { ID: 4, SRC_IMAGEN: "periodismo-deportivo.jpg", TITULO: "Imagen%203", ID_POST: 1, URL_POST: "un-ano-de-locos" }
    ];
    
export const typesPosts =
    [
        {
            ID: 0,
            NOMBRE: "Todos"
        },
        {
            ID: 1,
            NOMBRE: "Supera%20la%20Ficci%C3%B3n"
        },
        {
            ID: 2,
            NOMBRE: "PeP"
        },
        {
            ID: 3,
            NOMBRE: "Notas%20personales"
        },
        {
            ID: 5,
            NOMBRE: "Articulos"
        }
    ];

export const skills =
    [
        {
            ID: 3,
            NOMBRE_ITEM: "Locuci%C3%B3n",
            VALOR: 85,
            ID_TIPO_BARRA_PROGRESO: 2
        },
        {
            ID: 4,
            NOMBRE_ITEM: "Conducci%C3%B3n",
            VALOR: 95,
            ID_TIPO_BARRA_PROGRESO: 2
        },
        {
            ID: 5,
            NOMBRE_ITEM: "Experiencia",
            VALOR: 60,
            ID_TIPO_BARRA_PROGRESO: 2
        }
    ];

export const lenguages =
    [
        {
            ID: 1,
            NOMBRE_ITEM: "Espa%C3%B1ol",
            VALOR: 100,
            ID_TIPO_BARRA_PROGRESO: 1
        },
        {
            ID: 2,
            NOMBRE_ITEM: "Ingl%C3%A9s",
            VALOR: 70,
            ID_TIPO_BARRA_PROGRESO: 1
        }
    ];

export const experience =
    [
        {
            ID: 1,
            ID_TIPO_EXPERIENCIA: 1,
            TITULO: "Supera%20la%20Ficci%C3%B3n",
            ANIO_INICIO: 2020,
            ANIO_FIN: null,
            SUBTITULO: "Creador",
            DESCRIPCION: "Lorem%20ipsum%20dolor%20sit%20amet%2C%20consectetur%20adipiscing%20elit%2C%20sed%20do%20eiusmod%20tempor%20incididunt%20ut%20labore%20et%20dolore%20magna%20aliqua.%20Ut%20enim%20ad%20minim%20veniam%2C%20quis%20nostrud%20exercitation%20ullamco%20laboris%20nisi%20ut%20aliquip%20ex%20ea%20commodo%20consequat."
        },
        {
            ID: 2,
            ID_TIPO_EXPERIENCIA: 1,
            TITULO: "Pica%20en%20Punta",
            ANIO_INICIO: 2018,
            ANIO_FIN: 2019,
            SUBTITULO: "Conductor",
            DESCRIPCION: "Lorem%20ipsum%20dolor%20sit%20amet%2C%20consectetur%20adipiscing%20elit%2C%20sed%20do%20eiusmod%20tempor%20incididunt%20ut%20labore%20et%20dolore%20magna%20aliqua.%20Ut%20enim%20ad%20minim%20veniam%2C%20quis%20nostrud%20exercitation%20ullamco%20laboris%20nisi%20ut%20aliquip%20ex%20ea%20commodo%20consequat."
        }
    ];

export const education =
    [
        {
            ID: 3,
            ID_TIPO_EXPERIENCIA: 2,
            TITULO: "Colegio%20Santisimo%20Redentor",
            ANIO_INICIO: 2011,
            ANIO_FIN: 2016,
            SUBTITULO: "Bachillerato%20en%20Econom%C3%ADa",
            DESCRIPCION: "Lorem%20ipsum%20dolor%20sit%20amet%2C%20consectetur%20adipiscing%20elit%2C%20sed%20do%20eiusmod%20tempor%20incididunt%20ut%20labore%20et%20dolore%20magna%20aliqua.%20Ut%20enim%20ad%20minim%20veniam%2C%20quis%20nostrud%20exercitation%20ullamco%20laboris%20nisi%20ut%20aliquip%20ex%20ea%20commodo%20consequat."
        },
        {
            ID: 4,
            ID_TIPO_EXPERIENCIA: 2,
            TITULO: "Deportea",
            ANIO_INICIO: 2017,
            ANIO_FIN: 2020,
            SUBTITULO: "Periodismo%20Deportivo",
            DESCRIPCION: "Lorem%20ipsum%20dolor%20sit%20amet%2C%20consectetur%20adipiscing%20elit%2C%20sed%20do%20eiusmod%20tempor%20incididunt%20ut%20labore%20et%20dolore%20magna%20aliqua.%20Ut%20enim%20ad%20minim%20veniam%2C%20quis%20nostrud%20exercitation%20ullamco%20laboris%20nisi%20ut%20aliquip%20ex%20ea%20commodo%20consequat."
        }
    ];
